import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './config/cdnBase';
import './config/polyfills';
import { enableMocking } from './mocks/browser';

enableMocking().then(() => {
	const container = document.getElementById('root');
	const root = createRoot(container);
	root.render(React.createElement(App, {}, null));
});
